/**
 * Normalizes a URL string based on a set of predefined rules,
 * primarily to prepend 'https://' to incomplete URLs.
 *
 * @param {string} url The URL string to normalize.
 * @returns {string} The normalized URL.
 */
export function normalizeUrl(url) {
  if (typeof url !== 'string') {
    return '';
  }
  let normalized = url.trim();

  // If it's a payment link, return as is.
  if (normalized.toLowerCase().startsWith('payto://')) {
    return normalized;
  }

  // If it doesn't already have a protocol, attempt to add one.
  if (!normalized.startsWith('http://') && !normalized.startsWith('https://')) {
    if (normalized.startsWith('www.')) {
      normalized = 'https://' + normalized;
    } else {
      // Add protocol if it looks like a domain (contains a dot, no spaces)
      if (normalized.includes('.') && !normalized.includes(' ')) {
        normalized = 'https://' + normalized;
      }
    }
  }
  return normalized;
}
